import { createContext, useContext } from 'react';
import type {
  defaultBuddy,
  BuddyApi,
  BuddyMessage,
  BuddyPageContext,
  BuddySnapshot,
} from './companionApi';
export interface CompanionSessionValue {
  kidId: string;
  setupDeferred: boolean;
  deferSetup: () => void;
  returnTo: string;
  returnState: unknown;
  audience: 'kid' | 'parent';
  client: BuddyApi;
  snapshot: BuddySnapshot | null;
  profile: typeof defaultBuddy;
  loading: boolean;
  loadError: boolean;
  messages: BuddyMessage[];
  draft: string;
  setDraft: (value: string) => void;
  busy: boolean;
  paused: boolean;
  togglePause: () => void;
  error: string;
  setError: (value: string) => void;
  price: number | null;
  priceUnavailable: boolean;
  hasEarlier: boolean;
  loadingEarlier: boolean;
  earlierError: string;
  syncError: string;
  loadEarlier: () => Promise<void>;
  syncHistory: () => Promise<void>;
  send: (text: string, context: BuddyPageContext) => Promise<void>;
  stop: () => void;
  refresh: () => Promise<void>;
  update: (snapshot: BuddySnapshot, reset?: boolean) => void;
  helpOpen: boolean;
  setHelpOpen: (value: boolean) => void;
  page: BuddyPageContext | null;
  registerPage: (context: BuddyPageContext | null) => () => void;
}
export const CompanionContext = createContext<CompanionSessionValue | null>(null);
export function useCompanion() {
  const value = useContext(CompanionContext);
  if (!value) throw new Error('CompanionSession is missing');
  return value;
}
